import { AlertTriangle } from "lucide-react";
import { ChartRenderer } from "@/components/chat/ChartRenderer";
import { DECK } from "@/constants/testIds";

export function DeckSlide({ slide }) {
  return (
    <section data-testid={DECK.slide} className="rounded-xl border border-border/60 bg-card/50 p-5">
      <h3 className="text-base font-semibold text-foreground/90">{slide.title}</h3>
      <div className="mt-4 grid gap-6 lg:grid-cols-[1.5fr_1fr] lg:items-center">
        <div className="min-h-[220px] rounded-lg bg-background/40 p-2">
          {slide.error ? (
            <div className="flex items-center gap-2 rounded-lg border border-red-500/30 bg-red-500/5 p-3 text-xs text-red-400">
              <AlertTriangle className="h-4 w-4 shrink-0" /> Chart data unavailable for this slide.
            </div>
          ) : (
            <ChartRenderer chart={slide.chart} />
          )}
        </div>
        <ul className="space-y-2.5">
          {(slide.bullets || []).map((b, i) => (
            <li key={i} className="flex gap-2.5 text-sm leading-relaxed text-muted-foreground">
              <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-accent" />
              {b}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
